import { useState, useEffect, useCallback } from 'react';
import styles from '../styles/SuppliersSection.module.css';
import CustomSelect from './CustomSelect';
import AddSupplierModal from './AddSupplierModal';
import { API_URL } from '../config/api';


const SuppliersSection = () => {
  const [type, setType] = useState('');
  const [client, setClient] = useState('');
  const [suppliers, setSuppliers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  // Словарь для перевода типов компаний
  const orgTypeMap = {
    llp: 'ТОО',
    individual: 'ИП',
    jsc: 'АО',
    fl: 'ФЛ',
  };

  const fetchSuppliers = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/contractors?type=supplier`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();
      console.log('📦 Получено с API (suppliers):', data);

      if (Array.isArray(data?.data)) {
        setSuppliers(data.data);
      } else {
        console.warn('⚠️ Ответ API без data:', data);
        setSuppliers([]);
      }
    } catch (err) {
      console.error('❌ Ошибка загрузки поставщиков:', err);
      setSuppliers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSuppliers();
  }, [fetchSuppliers]);

  return (
    <div className={styles.container}>
      <button className={styles.addSuppliers} onClick={() => setShowModal(true)}>+</button>

      {showModal && (
        <AddSupplierModal
          onClose={() => setShowModal(false)}
          onSupplierAdded={() => {
            fetchSuppliers();        
            setShowModal(false);    
          }}
        />
      )}

      <div className={styles.filter}>
        <input type="text" className={styles.input} placeholder='Поиск по имени поставщика' />
        <input type="text" className={styles.input} placeholder='Имя директора' />
        <CustomSelect className={styles.filters__select} options={['Группа 1', 'Группа 2', 'Группа 3']} value={client} onChange={setClient} placeholder="Группа" />
        <input type="text" className={styles.input} placeholder='+7 (XXX) XXX-XX-XX' />
        <input type="text" className={styles.input} placeholder='ИИН/БИН' />
        <CustomSelect className={styles.filters__select} options={['ИП', 'ТОО', 'АО', 'ФЛ']} value={type} onChange={setType} placeholder="Тип компаний" />
        <input type="text" className={styles.input} placeholder='Город' />
      </div>

      <div className={styles.tableWrapper}>
        {loading ? (
          <p>Загрузка данных...</p>
        ) : (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Имя</th>
                <th>ИИН/БИН</th>
                <th>Телефон</th>
                <th>Тип</th>
                <th>Адрес</th>
                <th>Город</th>
                <th>Дата добавления</th>
              </tr>
            </thead>
            <tbody>
              {suppliers.length === 0 ? (
                <tr><td colSpan="7" style={{ textAlign: 'center' }}>Нет данных</td></tr>
              ) : (
                suppliers.map((item) => (
                  <tr key={item.id}>
                    <td>{item.name || '—'}</td>
                    <td>{item.sn || '—'}</td>
                    <td>{item.phone || '—'}</td>
                    <td>{orgTypeMap[item.org_type] || item.org_type || '—'}</td>
                    <td>{item.address || '—'}</td>
                    <td>{item.city || '—'}</td>
                    <td>{item.inserted_at?.split('T')[0] || '—'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default SuppliersSection;
